import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class ImpersonateRoute extends Route {
  @service("ember-store")
  store

  @service
  rpc

  model(params) {
    get(this, "rpc").execute("IMPERSONATE", { userId: params.user_id })
    return get(this, "store").find("user", params.user_id)
  }
}
